import { api } from '@/services'

export function fetchStates(params) {
  return api.get('/admin/state/list', { params: params })
}
